import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

export const PrivateRoute = ({ component, redirectTo, authData, dispatch, ...routeProps }) => {
  const Component = component;
  const defaultRoute = '/login';
  return (
    <Route
      {...routeProps}
      render={(componentProps) =>
        authData.loggedState ? <Component {...componentProps} /> : <Redirect to={redirectTo || defaultRoute} />
      }
    />
  );
};

function mapStateToProps(state) {
  return {
    authData: state.authData,
  };
}

export default connect(mapStateToProps)(PrivateRoute);
